import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ConnectPlatform').create(({ theme }) => ({
  contentRoot: {
    position: 'absolute',
    bottom: '5vh',
    background: theme.colors.background.primary,
    borderRadius: '12px',
    width: '90%',
    justifySelf: 'center',
    padding: '24px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    zIndex: 5,
  },

  headerWrapper: {
    display: 'flex',
    width: '100%',
    gap: '12px',
    alignItems: 'center',

    span: {
      color: theme.colors.text.primary,
      fontSize: '22px',
    },
  },

  platformImg: {
    width: '32px',
  },

  paragraphs: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    fontWeight: 300,
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: theme.sizes.texts.lineHeight.m,

    color: theme.colors.text.secondary,
  },

  voidInfoWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },

  void: {
    zIndex: '1',
    width: '45vh',
    paddingBottom: '-20vh',
  },

  tyan: {
    position: 'absolute',
    zIndex: '1',
    width: '80%',
    top: '-70%',
    maxWidth: '300px',
    paddingTop: '100px',
  },

  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  connectButton: {
    height: '52px',

    span: {
      fontSize: theme.sizes.texts.fontSize.m,
      fontWeight: 460,
    },
  },

  whatData: {
    color: theme.colors.text.link,
    textDecoration: 'underline',
    cursor: 'pointer',
  },

  noSteamButton: {
    background: 'transparent',
    width: '100%',
    height: '52px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: 'none !important',

    fontSize: '13px',
    textTransform: 'uppercase',
    fontWeight: 370,
    color: theme.colors.text.secondary,
  },
}))
